module.exports = __webpack_public_path__ + "static/media/lease4_img1.d801bb45.jpg";